import React, { FC, useState, useEffect } from 'react'
import {
    Drawer,
    Form,
    Button,
    Row,
    Space,
    Divider,
    Upload,
    Col,
    Input,
    Select,
} from 'antd'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import { toast } from 'react-toastify'
import ServiceAPI from '~services/services'
import to from 'await-to-js'
import { IProviderData } from '~types/provider'
import { ProviderType } from '~utils/games'

interface AddProps {
    close: () => void
    onloadData: () => void
    isOpen: boolean
}

const AddProviders: FC<AddProps> = ({ close, isOpen, onloadData }) => {
    const [form] = Form.useForm();
    const title = "Add Provider"
    const [btnLoading, setBtnLoading] = useState<boolean>(false)
    const [imageUpload, setImageUpload] = useState<string>("")
    const [imageBackground, setImageBackground] = useState<string>("")

    const insertData = async (values: IProviderData) => {
        const [err, res] = await to(ServiceAPI.addProviders(values))
        if (err) {
            toast.error(err?.message as string)
            setBtnLoading(false)
        } else {
            toast.success(res.message)
            setBtnLoading(false)
            onloadData()
            close()
        }
    }

    const handleFormSubmit = () => {
        form.validateFields()
            .then((values: IProviderData) => {
                setBtnLoading(true)
                if (!imageUpload || !imageBackground) {
                    toast.error("Please upload image")
                    setBtnLoading(false)
                }
                values.imageURL = imageUpload
                values.backgroundImageURL = imageBackground
                insertData(values)
            })
            .catch((errorInfo) => { });
    };


    const buttonUploadImage = (
        <div>
            {imageUpload ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload Logo</div>
        </div>
    );

    const buttonUploadBackground = (
        <div>
            {imageBackground ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload Background</div>
        </div>
    );

    const uploadImage = async (response: any, type: string) => {
        setBtnLoading(true)
        let formData: FormData = new FormData();
        formData.append('file', response.file);
        if (type === "image") {
            const [err, res] = await to(ServiceAPI.uploadImage(formData))
            if (err) {
                toast.error(err?.message as string)
                setBtnLoading(false)
            } else {
                toast.success(res?.message as string)
                setImageUpload(res?.link)
                setBtnLoading(false)
            }
        } else if (type === "background") {
            const [err, res] = await to(ServiceAPI.uploadImage(formData))
            if (err) {
                toast.error(err?.message as string)
                setBtnLoading(false)
            } else {
                toast.success(res?.message as string)
                setImageBackground(res?.link)
                setBtnLoading(false)
            }
        } else {
            return false
        }
    }


    const optionGameType = Object.keys(ProviderType).map((key: any) => {
        return <Select.Option key={key} value={key} >{Object.values(ProviderType)[key]}</Select.Option>
    })

    useEffect(() => {
        if (isOpen && form) {
            form.resetFields();
        }
    }, [isOpen, form]);

    return (
        <>
            <Drawer
                title={title}
                onClose={close}
                open={isOpen}
                bodyStyle={{ paddingBottom: 80 }}
                width={global.window.innerWidth <= 1200 ? global.window.innerWidth : global.window.innerWidth * .4}
                extra={
                    <Space>
                        <Button
                            onClick={handleFormSubmit}
                            type="primary"
                            loading={btnLoading}
                            size="large">
                            <i className="fa-solid fa-save me-2"></i>
                            Save
                        </Button>
                    </Space>
                }>
                <Form
                    form={form}
                    name="addGame"
                    layout="vertical">
                    <Row gutter={16}>
                        {/* <Col span={24}>
                            <Form.Item
                                name="provider"
                                label="Provider"
                                rules={[{ required: true, message: 'Please Select your Provider!' }]}
                                hasFeedback>
                                <Select
                                    placeholder="Select Provider"
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input: any, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }>
                                    {optionProvider}
                                </Select>
                            </Form.Item>
                        </Col> */}
                        <Col span={24}>
                            <Form.Item
                                name="name"
                                label="Name"
                                rules={[{ required: true, message: 'Please input your Name!' }]}
                                hasFeedback>
                                <Input placeholder="Name" inputMode="text" />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name="code"
                                label="Code"
                                rules={[{ required: true, message: 'Please input your Code!' }]}
                                extra={`Please enter in English, capital letters only.`}
                                hasFeedback>
                                <Input placeholder="Code" inputMode="text" onInput={(e: any) => e.target.value = e.target.value.toUpperCase()} />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name="type"
                                label="Type"
                                rules={[{ required: true, message: 'Please input your Type!' }]}
                                hasFeedback>
                                <Select
                                    style={{ width: 200 }}
                                    placeholder="Select Type">
                                    {optionGameType}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Row>
                            <Col span={12}>
                                <label style={{ marginBottom: '16px' }}>Logo</label>
                                <Upload
                                    name="upload-image"
                                    listType="picture-card"
                                    showUploadList={false}
                                    customRequest={(e) => uploadImage(e, 'image')}>
                                    {imageUpload ? <img src={imageUpload} alt="ImageUpload" style={{ width: '100%' }} /> : buttonUploadImage}
                                </Upload>
                            </Col>
                            <Col span={12}>
                                <label style={{ marginBottom: '16px' }}>Background Image</label>
                                <Upload
                                    name="background-image"
                                    listType="picture-card"
                                    showUploadList={false}
                                    customRequest={(e) => uploadImage(e, 'background')}>
                                    {imageBackground ? <img src={imageBackground} alt="imageBackground" style={{ width: '100%' }} /> : buttonUploadBackground}
                                </Upload>
                            </Col>
                        </Row>
                    </Row>
                    <Divider />
                    <div className="drawer-actions">
                        <Space>
                            <Button type="primary" htmlType="submit" disabled={btnLoading} onClick={handleFormSubmit} size="large"><i className="fa-solid fa-save me-2"></i> Save</Button>
                            <Button onClick={close} size="large">Close</Button>
                        </Space>
                    </div>
                </Form>
            </Drawer>
        </>
    )
}
export default AddProviders

